<template>
  <!-- Agenda items (breaks, meals, registration …) come from the `agenda`
       table, so the session detail route can't show them — its API looks the
       id up in `sessions`. Everything needed is already on the list payload,
       so the details are rendered from the object, no fetch. -->
  <c-modal
    v-if="showModal"
    :title="session.name"
    size="md"
    @close="closeModal"
  >
    <div class="modal-body agenda-info-modal">
      <div class="agenda-info-modal__meta">
        <time class="agenda-info-modal__time">
          <i class="fa-regular fa-clock"></i> {{ session.period_formatted }}
        </time>

        <marked-status v-if="session?.room?.name" icon="fa-location-dot">{{ session.room.name }}</marked-status>

        <colored-status v-if="session.in_progress" color="#e2544d">In Progress</colored-status>
      </div>

      <div v-if="session.description" class="agenda-info-modal__description">{{ session.description }}</div>
    </div>
    <div class="modal-footer">
      <c-button
        theme="default"
        size="md"
        icon="fa-close"
        @click="closeModal"
        uppercase
        fill
      >Close</c-button>
    </div>
  </c-modal>
</template>

<script>
import ColoredStatus from "../../../components/ui/ColoredStatus";
import MarkedStatus from "../../../components/ui/MarkedStatus";

export default {
  components: {
    ColoredStatus,
    MarkedStatus,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    session: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:showModal', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.agenda-info-modal {
  &__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--attendee-gap-sm);
    color: var(--attendee-text-primary-color);
  }

  &__description {
    margin-top: var(--attendee-gap-md);
    color: var(--attendee-text-primary-color);
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
}
</style>
